export interface TeamMembersFilters {
  /** Tag values — applied client-side over loaded users. */
  tags?: string[];
  /** Role values — applied client-side over loaded users. */
  roles?: string[];
  /** ms-epoch bounds on `lastActive` — applied client-side. */
  lastActiveRange?: { from?: number; to?: number };
}

export const teamMembersFiltersAreEqual = (a: TeamMembersFilters, b: TeamMembersFilters): boolean =>
  JSON.stringify(a) === JSON.stringify(b);

export const countTeamMembersActiveFilters = (filters: TeamMembersFilters): number => {
  let count = 0;
  if (filters.tags && filters.tags.length > 0) count++;
  if (filters.roles && filters.roles.length > 0) count++;
  if (
    filters.lastActiveRange &&
    (filters.lastActiveRange.from !== undefined || filters.lastActiveRange.to !== undefined)
  )
    count++;
  return count;
};
